export default __webpack_public_path__ + "static/media/steps.e0a67250.svg";